"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearAll = clearAll;
exports.clearNonPersistent = clearNonPersistent;
exports.getBuilder = getBuilder;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.string.starts-with.js");
var _storagebuilder = _interopRequireDefault(require("./storagebuilder"));
var _scopedstorage = _interopRequireDefault(require("./scopedstorage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function getBuilder(appId) {
  return new _storagebuilder.default(appId);
}
function clearStorage(storage, pred) {
  Object.keys(storage).filter(function (k) {
    return pred ? pred(k) : true;
  }).map(storage.removeItem.bind(storage));
}
function clearAll() {
  var storages = [window.sessionStorage, window.localStorage];
  storages.map(function (s) {
    return clearStorage(s);
  });
}
function clearNonPersistent() {
  var storages = [window.sessionStorage, window.localStorage];
  storages.map(function (s) {
    return clearStorage(s, function (k) {
      return !k.startsWith(_scopedstorage.default.GLOBAL_SCOPE_PERSISTENT);
    });
  });
}
//# sourceMappingURL=index.js.map